<template>
<svg viewBox="0 0 18 18" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-shipinjieru`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_9888a3a5b4__clip0_1240_275157)" fill-rule="evenodd" clip-rule="evenodd"><path d="M3 13.125V4.875H11.625V9.59898C12.0862 9.34959 12.591 9.17056 13.125 9.0763V7.30802L15.375 6.63302V9.19144C15.9185 9.34655 16.4242 9.59132 16.875 9.90872V6.12901C16.875 5.37542 16.1485 4.83491 15.4267 5.05146L13.125 5.74198V4.5C13.125 3.87868 12.6213 3.375 12 3.375H2.625C2.00368 3.375 1.5 3.87868 1.5 4.5V13.5C1.5 14.1213 2.00368 14.625 2.625 14.625H9.03868C9.01315 14.4203 9 14.2117 9 14C9 13.7015 9.02616 13.4091 9.0763 13.125H3ZM4.125 7.875H6.375V6.375H4.125V7.875Z"/><path d="M14 18C16.2091 18 18 16.2091 18 14C18 11.7909 16.2091 10 14 10C11.7909 10 10 11.7909 10 14C10 16.2091 11.7909 18 14 18ZM13.3536 12.8536C13.5488 12.6583 13.5488 12.3417 13.3536 12.1464C13.1583 11.9512 12.8417 11.9512 12.6464 12.1464L11.1464 13.6464C10.9512 13.8417 10.9512 14.1583 11.1464 14.3536L12.6464 15.8536C12.8417 16.0488 13.1583 16.0488 13.3536 15.8536C13.5488 15.6583 13.5488 15.3417 13.3536 15.1464L12.7071 14.5H16.5C16.7761 14.5 17 14.2761 17 14C17 13.7239 16.7761 13.5 16.5 13.5H12.7071L13.3536 12.8536Z"/></g><defs><clipPath id="svg_9888a3a5b4__clip0_1240_275157"><path d="M0 0H18V18H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconShipinjieru',
  props: {
    prefix: {
        type: String,
        default: 'zhilv',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
